import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import * as ApiPagination from '../interfaces/api/pagination';
import * as ApiVoucher from '../interfaces/api/voucher';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VoucherService extends BaseService {
  private urlVoucher = `${this.apiUrl}/voucher`;
  constructor(private http: HttpClient) {
    super();
  }

  getVocuherList(
    queryParams?: ApiPagination.RequestQuery,
  ): Observable<ApiPagination.ResponseBody<ApiVoucher.MHVoucher>> {
    const url = new URL(`${this.urlVoucher}`);
    if (queryParams?.page) {
      url.searchParams.set('page', queryParams.page?.toString());
    }

    if (queryParams?.per_page) {
      url.searchParams.set('perPage', queryParams.per_page?.toString());
    }

    return this.http.get<ApiVoucher.ResponseBodyVoucher>(url.href).pipe(
      map(pagination => ({
        ...pagination.data,
      })),
    );
  }

  getSingleVoucher(idVoucher: number) {
    return this.http.get<ApiVoucher.ResponseBodySingle>(`${this.urlVoucher}/${idVoucher}`);
  }

  takeVoucherByCode(payload: ApiVoucher.RequestTakeVoucherByCode) {
    return this.http.post<ApiVoucher.ResponseTakeVoucherByCode>(`${this.urlVoucher}/take_by_code`, payload);
  }

  takeVoucher(idVoucher: number) {
    return this.http.post<ApiVoucher.ResponseTakeVoucherByCode>(`${this.urlVoucher}/${idVoucher}/take`, {});
  }

  getVocuherListHistory(
    queryParams?: ApiVoucher.RequestQueryList,
  ): Observable<ApiPagination.ResponseBody<ApiVoucher.MDVoucher>> {
    const url = new URL(`${this.urlVoucher}/history`);
    url.searchParams.set('page', queryParams.page?.toString());
    if (queryParams.per_page) {
      url.searchParams.set('perPage', queryParams.per_page?.toString());
    }
    if (queryParams.is_usable) {
      url.searchParams.set('is_usable', queryParams.is_usable?.toString());
    }
    if (queryParams.is_used) {
      url.searchParams.set('is_used', queryParams.is_used?.toString());
    }

    return this.http.get<ApiVoucher.ResponseBodyVoucherHistory>(url.href).pipe(
      map(pagination => ({
        ...pagination.data,
      })),
    );
  }

  getSingleVoucherHistory(idMDVoucher: number) {
    return this.http.get<ApiVoucher.ResponseBodySingleVoucherHistory>(`${this.urlVoucher}/history/${idMDVoucher}`);
  }

  getUsableVoucher(): Observable<ApiPagination.ResponseBody<ApiVoucher.MDVoucher>> {
    const url = new URL(`${this.urlVoucher}/useable_voucher`);
    url.searchParams.set('perPage', '-1');
    url.searchParams.set('is_usable', '1');

    return this.http.get<ApiVoucher.ResponseBodyVoucherHistory>(url.href).pipe(
      map(pagination => ({
        ...pagination.data,
      })),
    );
  }

  checkVoucher(payload: { transactionId: number; voucherId: number }) {
    return this.http.post<ApiVoucher.ResponseVoucherCheck>(`${this.urlVoucher}/check`, {
      id_th_transaction: payload.transactionId.toString(),
      id_mh_voucher: payload.voucherId.toString(),
    });
  }

  useVoucher(payload: { transactionId: number; voucherId: number }) {
    return this.http.post<ApiVoucher.ResponseVoucherCheck>(`${this.urlVoucher}/use`, {
      id_th_transaction: payload.transactionId.toString(),
      id_mh_voucher: payload.voucherId.toString(),
    });
  }
}
